import ReactMenuItemType from "components/Editorial/ActionsMenu/PropTypes/ReactMenuItemType";
import React from "react";
import ToggleLockUser from "components/Editorial/ToggleLockUser";

export default function ReactMenuItem({
  item: {
    component,
    props,
  },
}) {
  if (component === "ToggleLockUser") {
    return <ToggleLockUser {...props} />;
  }

  return <React.Fragment />;
}

ReactMenuItem.propTypes = {
  item: ReactMenuItemType.isRequired,
};
